const UserDashboard = () => {
  return (
    <>
      <h2>UserDashboard</h2>
    </>
  );
};

export default UserDashboard;
